export const CONTACTS = {
  phone: import.meta.env.VITE_CONTACTS_PHONE,
  email: import.meta.env.VITE_CONTACTS_EMAIL,
  supportBlocks: [
    {
      title: 'contacts.support',
      contacts: [
        {
          type: 'phone',
          label: '+374 55 743 283',
          url: 'tel:+37455743283'
        }
      ]
    },
    {
      title: 'contacts.online.support',
      footer: 'contacts.online.support.footer',
      contacts: [
        {
          type: 'phone',
          label: '+374 55 743 283',
          url: 'tel:+37455743283'
        }
      ]
    }
  ]
}

export const CART_FEATURES: { key: number, icon: string }[] = []
